module.exports = __webpack_public_path__ + "static/media/img-mkt-banner@3x.d05d734c.png";